import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
// import { generalApiSlice } from "../services/generalApi";
import authReducer from "../features/authSlice";
import appReducer from "../features/appSlice";


export const store = configureStore({
  reducer: {
    auth: authReducer,
    app: appReducer,
    // [generalApiSlice.reducerPath]: generalApiSlice.reducer,
  },
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware().concat(generalApiSlice.middleware),
});

// Optional, but required for refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
